(function () {
  'use strict';

  function syncButtonState(trigger, realButton) {
    trigger.disabled = realButton.disabled;
    trigger.innerHTML = realButton.innerHTML;
  }

  // バリアントを持つ商品向け：本物の variant-picker ブロックを複製せずその場で
  // ポップアップへ一時的に移動し、閉じたら元の位置へ戻す（複製しないため id 重複が起きない）。
  // ポップアップ内には専用の「カートに追加」ボタンを置かず、トリガーボタン自身が
  // 「1回目クリックで開く／2回目クリックでカートに追加する」の2段階で機能する。
  // 見た目は開閉にかかわらず常に同じ通常デザインのまま変えない。
  function initVariantPopover(bar, targetButtonSelector) {
    var chooseOptionsButton = bar.querySelector('[data-floating-choose-options-trigger] button');
    var popover = bar.querySelector('[data-floating-variant-popover]');
    if (!chooseOptionsButton || !popover) return;

    var variantPickerSelector = popover.getAttribute('data-variant-picker-selector');
    var slot = popover.querySelector('[data-floating-variant-picker-slot]');
    var closeTriggers = popover.querySelectorAll('[data-floating-variant-popover-close]');
    var originalParent = null;
    var originalNextSibling = null;
    var variantPicker = null;

    chooseOptionsButton.setAttribute('aria-expanded', 'false');

    function isOpen() {
      return popover.classList.contains('is-open');
    }

    function syncFromRealButton() {
      var realButton = document.querySelector(targetButtonSelector);
      if (realButton) syncButtonState(chooseOptionsButton, realButton);
    }

    function open() {
      variantPicker = document.querySelector(variantPickerSelector);
      if (variantPicker && slot && variantPicker.parentElement !== slot) {
        originalParent = variantPicker.parentElement;
        originalNextSibling = variantPicker.nextSibling;
        slot.appendChild(variantPicker);
      }

      popover.classList.add('is-open');
      chooseOptionsButton.setAttribute('aria-expanded', 'true');
      document.addEventListener('keydown', onKeydown);
      syncFromRealButton();

      var firstCloseButton = popover.querySelector('.floating-variant-popover__close');
      if (firstCloseButton) firstCloseButton.focus();
    }

    function close() {
      if (variantPicker && originalParent) {
        originalParent.insertBefore(variantPicker, originalNextSibling);
      }
      variantPicker = null;
      originalParent = null;
      originalNextSibling = null;

      popover.classList.remove('is-open');
      chooseOptionsButton.setAttribute('aria-expanded', 'false');
      document.removeEventListener('keydown', onKeydown);
      chooseOptionsButton.focus();
    }

    function onKeydown(event) {
      if (event.key === 'Escape') close();
    }

    chooseOptionsButton.addEventListener('click', function () {
      if (isOpen()) {
        var realButton = document.querySelector(targetButtonSelector);
        if (realButton) realButton.click();
      } else {
        open();
      }
    });

    closeTriggers.forEach(function (closeTrigger) {
      closeTrigger.addEventListener('click', close);
    });

    document.addEventListener('variant:change', function () {
      if (isOpen()) syncFromRealButton();
    });

    document.addEventListener('variant:add', close);
  }

  function initSection(bar) {
    if (!bar || bar.hasAttribute('data-floating-add-to-cart-bound')) return;

    var targetButtonSelector = bar.getAttribute('data-target-button-selector');
    if (!targetButtonSelector) return;

    var realButton = document.querySelector(targetButtonSelector);
    if (!realButton) return;

    bar.setAttribute('data-floating-add-to-cart-bound', 'true');

    // バリアントを持たない商品の場合のみ、実際の「カートに追加」ボタンへクリックを委譲する
    // （バリアントを持つ商品はポップアップ内の同じマーカーのボタンがこれを担う）
    var trigger = bar.querySelector('[data-floating-add-to-cart-trigger] button');
    if (trigger) {
      trigger.addEventListener('click', function () {
        var currentRealButton = document.querySelector(targetButtonSelector);
        if (currentRealButton) currentRealButton.click();
      });

      document.addEventListener('variant:change', function () {
        var currentRealButton = document.querySelector(targetButtonSelector);
        if (currentRealButton) syncButtonState(trigger, currentRealButton);
      });

      syncButtonState(trigger, realButton);
    }

    initVariantPopover(bar, targetButtonSelector);

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        bar.classList.toggle('is-visible', !entry.isIntersecting);
      });
    });
    observer.observe(realButton);
  }

  function initAll() {
    document
      .querySelectorAll('.floating-add-to-cart-bar:not([data-floating-add-to-cart-bound])')
      .forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // テーマエディタでの再描画対応
  document.addEventListener('shopify:section:load', function (event) {
    var bar = event.target.querySelector('.floating-add-to-cart-bar');
    if (bar) initSection(bar);
  });
})();
